<div class="colour-picker">
    <dx-color-box [value]="value ?? null"
                  (onValueChanged)="onColorChange($event)"
                  applyButtonText="OK"
                  cancelButtonText="Cancel"
                  placeholder="Select a colour..."
                  [openOnFieldClick]="true"
                  [editAlphaChannel]="true"
                  [showClearButton]="true"
                  applyValueMode="instantly"
                  [readOnly]="disabled">
        <dxo-color-box-drop-down-options [wrapperAttr]="{ class: 'colour-picker-dropdown' }"></dxo-color-box-drop-down-options>
    </dx-color-box>

    @if (presets && presets.length > 0) {
        <div>
            <div class="d-flex flex-row gap-1 align-items-center">
                <button class="btn colour-swatch"
                        adaptTooltip="Lighter colours"
                        [disabled]="!canGoLighter || disabled"
                        (click)="goLighter()">
                    <i class="fas fa-fw fa-arrow-left"></i>
                </button>

                <div class="colour-presets">
                    @for (colour of presets; track colour) {
                        <ng-container *ngTemplateOutlet="colourPreset; context: { colour }"></ng-container>
                    }
                </div>

                <button class="btn colour-swatch"
                        adaptTooltip="Darker colours"
                        [disabled]="!canGoDarker || disabled"
                        (click)="goDarker()">
                    <i class="fas fa-fw fa-arrow-right"></i>
                </button>

                @if (expandedPresets && expandedPresets.length > 0) {
                    <div class="d-flex gap-2 flex-grow-1 align-items-center">
                        <button adaptTooltip="{{expandedPresetsCollapsed ? 'Show' : 'Hide'}} more colours"
                                [hideTooltipOnBlurred]="false"
                                [(adaptCollapsibleButton)]="expandedPresetsCollapsed"
                                (adaptCollapsibleButtonChange)="expandedPresetsCollapsedChange.emit($event)"></button>
                    </div>
                }
            </div>
            @if (expandedPresets && expandedPresets.length > 0) {
                <div [collapse]="expandedPresetsCollapsed"
                     [isAnimated]="true"
                     class="overflow-hidden m-0">
                    <div class="colour-presets pt-1 pb-1">
                        @for (colour of expandedPresets; track colour) {
                            <ng-container *ngTemplateOutlet="colourPreset; context: { colour }"></ng-container>
                        }
                    </div>
                </div>
            }
        </div>
    }

    <div class="colour-preset-groups">
        @for (presetGroup of presetGroups; track presetGroup.key) {
            <ng-container *ngTemplateOutlet="colourPresetGroup; context: { presetGroup }"></ng-container>
        }
    </div>
</div>

<ng-template #colourPresetGroup
             let-presetGroup="presetGroup">
    <div class="colour-preset-group">
        @if (presetGroup.key) {
            <label>{{ presetGroup.key }}</label>
        }
        <div class="colour-presets">
            @for (colour of presetGroup.items; track colour) {
                <ng-container *ngTemplateOutlet="colourPreset; context: { colour }"></ng-container>
            }
        </div>
    </div>
</ng-template>

<ng-template #colourPreset
             let-colour="colour">
    @let selected = selectedPreset === colour || value === colour;
    <div class="colour-swatch"
         [style.--swatch-bg]="colour"
         [style.background-color]="colour"
         [class.selected]="selected"
         (click)="!disabled && selectPreset(colour)">
        @if (selected) {
            <i class="fas fa-fw fa-check selected-icon"
               [class.light-palette]="presetSet === 'light'"></i>
        }
    </div>
</ng-template>
